import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import publicApiClient, { CollectionCodeResponse } from '../../../api/public';

const usePublicCollectionCodeQuery = (
  confirmationNumber: string,
  orderId: string,
) => {
  const queryKey = ['publicCollectionCodes', confirmationNumber, orderId];
  const queryClient = useQueryClient();

  const query = useQuery<CollectionCodeResponse>({
    queryKey,
    queryFn: () =>
      publicApiClient.getCollectionCodes(confirmationNumber, orderId),
    enabled: !!confirmationNumber && !!orderId,
    staleTime: 0, // Always consider data stale to ensure fresh data
    gcTime: 60000, // Keep in cache for 1 minute
  });

  // Set up refetch interval for inProgress status
  useEffect(() => {
    if (query.data?.status === 'inProgress') {
      const interval = setInterval(() => {
        queryClient.invalidateQueries({ queryKey });
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [query.data?.status, queryClient, queryKey]);

  return query;
};

export default usePublicCollectionCodeQuery;
